import * as React from "react"

const Spotify = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6Zm2.775 8.7c-.15.15-.3.225-.525.15-1.425-.9-3.15-1.05-5.25-.6-.225.075-.375-.075-.45-.3-.075-.225.075-.375.3-.45 2.25-.525 4.275-.3 5.85.675.15.075.15.3.075.525Zm.675-1.65c-.15.225-.45.3-.6.15-1.65-.975-4.05-1.275-6-.675-.225 0-.45-.075-.525-.375-.075-.225.075-.45.3-.525 2.175-.675 4.875-.3 6.75.825.15.075.225.375.075.6Zm.075-1.725C9.575 6.2 6.425 6.05 4.55 6.65c-.3.075-.6-.075-.675-.375-.075-.3.075-.6.375-.675 2.1-.6 5.625-.525 7.875.825.3.15.375.525.225.75-.15.225-.525.3-.825.15Z" />
  </svg>
)

export default Spotify
